import React from "react";
import { assertNever } from "../../../amorg-common";
import { IconWithText } from "./IconWithText";


export function StatusIconWithText (props: {
    variant: 'success' | 'pending' | 'warning';
    text: string;
    tooltip?: React.ReactNode;
    tooltipAlignment?: 'left' | 'right';
}): JSX.Element
{

    if (props.variant === 'pending')
        return (
            <IconWithText
                tooltipContent={props.tooltip}
                tooltipAlignment={props.tooltipAlignment}
                variant='passive'
                icon='clock'
            >
                {props.text}
            </IconWithText>
        );

    else if (props.variant === 'warning')
        return (
            <IconWithText
                tooltipContent={props.tooltip}
                tooltipAlignment={props.tooltipAlignment}
                variant='warning'
                icon='warning'
            >
                {props.text}
            </IconWithText>
        );

    else if (props.variant === 'success')
        return (
            <IconWithText
                tooltipContent={props.tooltip}
                tooltipAlignment={props.tooltipAlignment}
                variant='success'
                icon='status_ok'
            >
                {props.text}
            </IconWithText>
        );


    else
        assertNever(props.variant);
}
